// TODO: odstranit DMS_MODULE je nutno podivat se kde vsude se pouziva
export const DMS_MODULE = 'WmsMenu';
export const NAME = 'WmsMenu';
